"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XeroIconButton = exports.StripeIconButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var xero_svg_1 = __importDefault(require("assets/images/accountingSoftwares/xero.svg"));
var Stripe_svg_1 = __importDefault(require("assets/images/Stripe.svg"));
var Tooltip_1 = __importDefault(require("atomicComponents/atoms/Tooltip"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var InvoiceLogoButton = function (_a) {
    var svg = _a.svg, disabled = _a.disabled, disabledMsg = _a.disabledMsg, url = _a.url, brandColor = _a.brandColor, height = _a.height, width = _a.width;
    var SVG = (0, utils_1.makeSuperSVG)(svg);
    var content = (0, jsx_runtime_1.jsx)(SVG, { height: height, width: width, disabled: disabled });
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: disabled
            ? ((0, jsx_runtime_1.jsx)(Tooltip_1.default, __assign({ variant: "dark", title: disabledMsg !== null && disabledMsg !== void 0 ? disabledMsg : 'Available when invoice is finalised', placement: "bottom" }, { children: (0, jsx_runtime_1.jsx)("span", { children: content }) })))
            : (0, jsx_runtime_1.jsx)(utils_1.LinkLogo, __assign({ brandColor: brandColor, href: url }, { children: content })) }));
};
exports.StripeIconButton = (0, DefaultPropsHoC_1.default)(InvoiceLogoButton, {
    svg: Stripe_svg_1.default,
    height: constants_1.ICON_BUTTON_SIZES.medium.stripe.height,
    brandColor: '#635BFF',
});
exports.XeroIconButton = (0, DefaultPropsHoC_1.default)(InvoiceLogoButton, {
    svg: xero_svg_1.default,
    height: constants_1.ICON_BUTTON_SIZES.medium.xero.height,
    brandColor: '#13B5EA',
});
